import { ChainId } from '@ui/types/chain';
import { getContract, PublicClient, WalletClient } from 'viem';

import SwapFacet from '../abis/SwapFacet';
import { getContractAddress } from '../constants/address';

export const getSwapFacet = ({
  chainId,
  publicClient,
  walletClient,
}: {
  publicClient: PublicClient;
  walletClient?: WalletClient;
  chainId: ChainId;
}) => {
  const address = getContractAddress('LeverUp', chainId);
  if (!address) throw new Error('Contract address not found');

  return getContract({
    abi: SwapFacet,
    address,
    client: {
      public: publicClient,
      wallet: walletClient,
    },
  });
};

